module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAiklEQVR42u3aQQrAIAwEwDy9P0/PhULtQbHdCexRhDkkEazuruQUAAAAAAAAAAAAAADhAFVHP+WuRs7tGAAAAABYBrBpAQAA4LoJzrvpC00QAAAA2QDGIAAAALwGAQAAEAvQeQUAAICXTfBPAQAAAABTAAAAAJogAAAAfJQEAAAAAAAAAAAAACAvJ39wXkfI72P4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Greece.png
// module id = mNCz
// module chunks = 0 62 63